import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Vitals(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#3B1A51" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <g clipPath="url(#clip0_2593_21952)">
        <path
          d="M11.9388 11.7988C12.0115 11.1802 12.4535 10.708 13.0815 10.6126C13.3619 10.5701 13.6625 10.5701 13.9399 10.622C14.5872 10.7441 15.0381 11.2361 15.0733 11.9135C15.1138 12.6928 15.0826 13.4761 15.0826 14.2756H14.1867C14.1763 14.1881 14.1649 14.0937 14.1535 14.0007C14.1352 13.9968 14.1145 13.9859 14.108 13.9918C13.6304 14.4106 12.8679 14.4848 12.3186 14.1619C12.0876 14.0264 11.9368 13.8286 11.877 13.5651C11.7212 12.8822 12.0367 12.3249 12.7186 12.142C13.042 12.055 13.3822 12.0288 13.7154 11.9793C13.8524 11.959 13.9914 11.9501 14.1288 11.9358C14.0977 11.6554 13.9592 11.4903 13.6996 11.4309C13.4089 11.3647 13.0771 11.3859 12.8288 11.7988H11.9388ZM14.1486 12.7111C13.7664 12.723 13.3925 12.7462 13.0281 12.8516C12.8743 12.8961 12.768 12.9935 12.7685 13.17C12.7685 13.3272 12.8669 13.4553 13.043 13.5092C13.3451 13.6017 13.6324 13.5552 13.891 13.3792C14.114 13.2269 14.203 13.0098 14.1491 12.7116L14.1486 12.7111Z"
          fill="white"
        />
        <path
          d="M19.8855 11.7291H18.9618C18.8288 11.4487 18.5677 11.3351 18.2765 11.3914C18.1385 11.4181 18.05 11.5051 18.0386 11.6633C18.0268 11.8235 18.139 11.8987 18.2765 11.9333C18.5479 12.001 18.8199 12.0668 19.0933 12.1242C19.8894 12.2913 20.1055 12.9208 19.9562 13.5829C19.8815 13.9141 19.6471 14.1258 19.3356 14.2351C18.8021 14.422 18.2656 14.4155 17.7474 14.1817C17.3083 13.9834 17.0591 13.6387 17.0205 13.1334H17.9303C18.093 13.4963 18.4124 13.5487 18.769 13.5146C18.9188 13.5003 19.0493 13.4404 19.0721 13.2753C19.0963 13.0988 18.9658 13.0246 18.8243 12.988C18.5618 12.9203 18.2953 12.8674 18.0312 12.806C17.3844 12.6567 17.0477 12.1914 17.1179 11.5441C17.1595 11.1659 17.3736 10.9043 17.7058 10.7471C18.2087 10.5087 18.7294 10.5038 19.2362 10.7263C19.6501 10.9078 19.8439 11.2578 19.886 11.7296L19.8855 11.7291Z"
          fill="white"
        />
        <path
          d="M5.80036 12.9016C6.05848 12.1668 6.31659 11.4325 6.57668 10.6913H7.54931C7.11368 11.9013 6.68646 13.0865 6.25676 14.2802H5.29254C4.8668 13.0984 4.4381 11.9097 4.00049 10.6952H4.9741C5.23271 11.4315 5.49082 12.1668 5.74943 12.9016H5.80086H5.80036Z"
          fill="white"
        />
        <path
          d="M9.7092 9.60498H10.6388V10.6716H11.5125V11.4909H10.6403V12.1901C10.6403 12.4289 10.6403 12.6677 10.6403 12.9066C10.6403 13.2748 10.8206 13.4589 11.1812 13.4589C11.2866 13.4589 11.3919 13.4589 11.514 13.4589V14.2936C11.0997 14.2777 10.6818 14.346 10.2714 14.2407C9.90897 14.1477 9.72206 13.8574 9.7186 13.4065C9.71464 12.871 9.71761 12.3359 9.71761 11.8004C9.71761 11.7109 9.71761 11.6214 9.71761 11.5122C9.54504 11.5003 9.39225 11.4899 9.22363 11.4785V10.6943C9.37642 10.6844 9.52823 10.6745 9.7097 10.6627V9.60498H9.7092Z"
          fill="white"
        />
        <path
          d="M16.8519 13.4839V14.2771C16.57 14.3067 16.2931 14.3156 16.0226 14.2355C15.7863 14.1658 15.6216 14.0066 15.5529 13.7688C15.5168 13.6437 15.495 13.5101 15.4945 13.3801C15.4901 12.177 15.4921 10.9745 15.4926 9.77145C15.4926 9.72299 15.497 9.67502 15.5005 9.60876H16.4192V9.87479C16.4192 10.9127 16.4192 11.9511 16.4192 12.989C16.4192 13.2754 16.5633 13.4404 16.8514 13.4839H16.8519Z"
          fill="white"
        />
        <path d="M8.79291 14.2807H7.90088V10.7012H8.79291V14.2807Z" fill="white" />
        <path d="M7.90527 9.60767H8.78939V10.3741H7.90527V9.60767Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_2593_21952">
          <rect fill="white" height="4.76176" transform="translate(4.00049 9.60486)" width="15.9996" />
        </clipPath>
      </defs>
    </svg>
  );
}

Vitals.propTypes = propTypes;
Vitals.defaultProps = defaultProps;

export default Vitals;
